/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import { FC } from 'react';
import {
    Edit,
    TextInput,
    PasswordInput,
    Toolbar,
    useTranslate,
    SelectInput,
    FormWithRedirect,
    required,
    email,
    BooleanInput,
} from 'react-admin';
import {
    Box,
    Card,
    CardContent,
    Typography,
    Divider,
    makeStyles,
    Grid,
} from '@material-ui/core';

import { validatePasswords } from './UserCreate';
import { ValidationSwitcher } from './UserShow';

const useStyles = makeStyles(theme => ({
    toolbar: {
        padding: theme.spacing(2), // or '16px'
    },
    defaultToolbar: {
        padding: '20px 0px',
    },
}));
const EditForm = (props: any) => {
    const translate = useTranslate();
    const classes = useStyles();

    return (
        <FormWithRedirect
            {...props}
            validate={validatePasswords}
            render={(formProps: any) => (
                <Card>
                    <form>
                        <CardContent>
                            <Grid container spacing={3}>
                                {/* Informations Personnelles */}
                                <Grid item xs={12} md={6}>
                                    <Typography variant="h6" gutterBottom>
                                        Informations Personnelles
                                    </Typography>

                                    <TextInput
                                        source="name"
                                        resource="users"
                                        label="Nom"
                                        validate={[required()]}
                                        fullWidth
                                    />

                                    <TextInput
                                        type="email"
                                        source="email"
                                        resource="users"
                                        label="Email"
                                        validate={[email(), required()]}
                                        fullWidth
                                    />

                                    <TextInput
                                        source="phone"
                                        label="Téléphone"
                                        resource="users"
                                        fullWidth
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Typography variant="h6" gutterBottom>
                                        Type de Document
                                    </Typography>

                                    <SelectInput
                                        source="document_type"
                                        label="Type de document d'identité"
                                        choices={[
                                            {
                                                id: 'cni',
                                                name: "Carte Nationale d'Identité",
                                            },
                                            {
                                                id: 'passport',
                                                name: 'Passeport',
                                            },
                                        ]}
                                        fullWidth
                                    />
                                </Grid>

                                {/* Adresse */}
                                <Grid item xs={12}>
                                    <Divider style={{ margin: '16px 0' }} />
                                    <Typography variant="h6" gutterBottom>
                                        Adresse
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <TextInput
                                        source="address1"
                                        label="Adresse ligne 1"
                                        resource="users"
                                        fullWidth
                                    />

                                    <TextInput
                                        source="address2"
                                        label="Adresse ligne 2"
                                        resource="users"
                                        fullWidth
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <TextInput
                                        source="rib"
                                        label="RIB"
                                        resource="users"
                                        fullWidth
                                    />
                                </Grid>

                                <BooleanInput
                                    source="account_enabled"
                                    label="resources.drivers.fields.account_enabled"
                                    fullWidth
                                />
                                <Box mt="1em" />

                                {/* Géolocalisation */}
                                <Grid item xs={12}>
                                    <Divider style={{ margin: '16px 0' }} />
                                    <Typography variant="h6" gutterBottom>
                                        Géolocalisation
                                    </Typography>

                                    {formProps.record?.location
                                        ?.coordinates && (
                                        <Box>
                                            <Typography variant="body2">
                                                Longitude:{' '}
                                                {
                                                    formProps.record.location
                                                        .coordinates[0]
                                                }
                                            </Typography>
                                            <Typography variant="body2">
                                                Latitude:{' '}
                                                {
                                                    formProps.record.location
                                                        .coordinates[1]
                                                }
                                            </Typography>
                                        </Box>
                                    )}
                                </Grid>
                                <Divider style={{ margin: '16px 0' }} />

                                <Grid item xs={12}>
                                    <Box mt="1em" />
                                    <Divider style={{ margin: '16px 0' }} />

                                    <Typography variant="h6" gutterBottom>
                                        Statut de Validation
                                    </Typography>
                                    <ValidationSwitcher
                                        record={formProps.record}
                                    />
                                </Grid>

                                {/* Changement de mot de passe */}
                                <Grid item xs={12}>
                                    <Divider style={{ margin: '16px 0' }} />
                                    <Typography variant="h6" gutterBottom>
                                        Changement de mot de passe
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <PasswordInput
                                        source="password"
                                        label="Mot de passe"
                                        resource="users"
                                        fullWidth
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <PasswordInput
                                        source="confirm_password"
                                        label="Confirmer le mot de passe"
                                        resource="users"
                                        fullWidth
                                    />
                                </Grid>
                            </Grid>
                        </CardContent>

                        <Toolbar
                            record={formProps.record}
                            basePath={formProps.basePath}
                            undoable={false}
                            invalid={formProps.invalid}
                            handleSubmit={formProps.handleSubmit}
                            saving={formProps.saving}
                            resource="users"
                            classes={{
                                root: classes.toolbar,
                                defaultToolbar: classes.defaultToolbar,
                            }}
                        />
                    </form>
                </Card>
            )}
        />
    );
};

export default EditForm;
